import { render, staticRenderFns } from "./hub-video.vue?vue&type=template&id=5a8ff07a"
import script from "./hub-video.vue?vue&type=script&lang=js"
export * from "./hub-video.vue?vue&type=script&lang=js"
import style0 from "./hub-video.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports